import { enqueueSnackbar } from "notistack";
import { useForm } from "react-hook-form";

import FormLabel from "~/components/login/formLabel/FormLabel";
import Button from "~/components/ui/button/Button";
import Input from "~/components/ui/input/Input";
import Modal from "~/components/ui/modal/Modal";
import { messageFromError } from "~/helpers/messageFromError";
import { tryCatch } from "~/helpers/tryCatch";

import { RenameDashboardFormValues, RenameDashboardModalProps } from "./types";

export const RenameDashboardModal = ({
  isOpen,
  onClose,
  dashboard,
  updateName,
}: RenameDashboardModalProps) => {
  const onSubmit = async (values: RenameDashboardFormValues) => {
    const result = await tryCatch(updateName(values.name));
    if (result.error) {
      enqueueSnackbar(messageFromError(result.error), {
        variant: "error",
        persist: true,
      });

      return;
    }

    onClose();
  };

  const { handleSubmit, register, formState } =
    useForm<RenameDashboardFormValues>({
      defaultValues: {
        name: dashboard.name,
      },
    });

  return (
    <Modal
      isOpen={isOpen}
      modalLabel={<h3>Let's give a new name to your dashboard</h3>}
      closeModal={onClose}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <FormLabel label="Name" />
          <Input {...register("name")} />
        </div>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            marginTop: "1rem",
            justifyContent: "flex-end",
          }}
        >
          <Button outlined onClick={onClose}>
            Cancel
          </Button>
          <Button withSpinner={formState.isSubmitting} type="submit">
            Rename
          </Button>
        </div>
      </form>
    </Modal>
  );
};
